<template>
  <div class="pt-model-list">
    <r-text style="margin-bottom: 16px;">
      Выберите модель
    </r-text>
    <div class="pt-model-list-content" v-loading="loading">
      <div class="pt-model-list-search">
        <el-input
          prefix-icon="el-icon-search"
          class="r-input"
          v-model="filter"
          placeholder="Поиск по названию модели"
        />
      </div>
      <ul class="pt-model-list-list" v-if="filteredModels.length">
        <li
          class="pt-model-list-item"
          v-for="item in filteredModels"
          :key="item.id"
          @click="changeModel(item)"
        >
          <div class="pt-model-list-item-icon">
            <r-icon name="model" :size="18" />
          </div>
          <div class="pt-model-list-item-info">
            <r-text>{{ item.name }}</r-text>
            <r-text type="caption">
              {{ item.children.length }} внутр. ИД
            </r-text>
          </div>
          <div class="pt-model-list-item-action">
            <el-tooltip
              :open-delay="1000"
              content="Обновить маршрутизатор"
              placement="top"
            >
              <r-icon
                name="line"
                :size="18"
                @click.native.stop="enableRouteHandler(item)"
              />
            </el-tooltip>
          </div>
        </li>
      </ul>
      <div class="pt-model-list-nodata" v-else>
        <r-text type="caption">
          Нет доступных моделей
        </r-text>
      </div>
    </div>
  </div>
</template>

<script>
import { getDatasourcesByDatatype, notifyFactory, errorParser } from "@/utils";

export default {
  data() {
    return {
      models: [],
      model: "",
      filter: "",
      loading: false
    };
  },
  computed: {
    filteredModels() {
      return this.models.filter(
        m => m.name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1
      );
    }
  },
  methods: {
    changeModel(model) {
      this.$emit("change-model", model);
    },
    enableRouteHandler(model) {
      this.$store
        .dispatch("POST_OSRM_REQUEST", { id: model.id })
        .then(response => {
          // eslint-disable-next-line
          const message = `Запрос на включение маршрутизатора отправлен. Номер задачи - ${response.data.task_id}`;
          this.$notify(notifyFactory("success", "Запрос отправлен", message));
          this.$store.commit("ADD_ACTIVE_TASK", {
            task_id: response.data.task_id,
            type: "other",
            description: `Включение маршрутизатора для ИД - ${model.name}`,
            source_id: model.id
          });
        })
        .catch(error => {
          const message =
            "Запрос на включение маршрутизатора не отправлен. Повторите попытку";
          const title = "Запрос не отправлен";
          errorParser.call(this, error, message, title);
        });
    }
  },
  async created() {
    try {
      this.loading = true;
      const where = {
        field: "datatype",
        op: "=",
        value: "model",
        type: "AND"
      };
      const include = { children: {} };
      const models = await getDatasourcesByDatatype(this, where, include);

      this.models = models.filter(
        ds =>
          ds.children.filter(
            l => l.datatype === "stop_points" || l.datatype === "line_routes"
          ).length
      );
      this.loading = false;
    } catch (error) {
      console.log(error);
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
.pt-model-list {
  &-header {
    margin-bottom: 16px;
  }

  &-content {
    min-height: 64px;
  }

  &-search {
    margin-bottom: 8px;
  }

  &-list {
    max-height: 35vh;
    overflow: auto;
    background-color: var(--modal_bg) !important;
    border-radius: var(--border-radius);
    padding: 8px 0;
  }

  &-item {
    cursor: pointer;
    border-radius: var(--border-radius);
    display: flex;
    padding: 2px 16px;

    &:not(:last-child) {
      margin-bottom: 8px;
    }

    &-icon {
      margin-right: 12px;
    }

    &:hover {
      background-color: rgba(var(--accent_primary), 0.2);

      .pt-model-list-item-action {
        display: block;
      }
    }

    &:active {
      background-color: rgba(var(--accent_primary), 0.3);
    }

    &-action {
      margin-left: auto;
      display: none;
    }
  }

  &-nodata {
    padding: 16px;
    text-align: center;
  }
}
</style>
